﻿import { defineComponent, PropType } from 'vue';

import select_passengers from "../common/passenger/select_passengers.vue";
import tour from "./tour.vue";

import { trip } from "../../../objects/v1_2/Booking/Trip";

import { product_search } from "../../../objects/v1_3/product/search/product_search";
import { product_search_product } from "../../../objects/v1_3/product/search/product_search_product";

import { Booking } from '../../../services/booking';
import { Product } from '../../../services/product';
import { Hidden_Tours } from '../../../services/hidden_tours';
import { Currency_Service } from "../../../../system/services/currency";
import { passenger } from '../../../objects/v1_2/Booking/Passenger';

const Book = new Booking();
const Prod = new Product();
const Hidden = new Hidden_Tours();
const Currency_Services = new Currency_Service();

export default defineComponent({
    name: "add-ons",
    components: {
        select_passengers,
        tour
    },
    data() {
        return {
            product_search: new product_search() as product_search,
            suggested_tours: [] as product_search_product[],
            loading_suggestions: true as boolean,
            suggestion_request: 0 as number
        }
    },
    methods: {
        async Download_Product_Search() {
            const product_search = await Prod.Get_Product_Search();
            await Hidden.Load();
            // hidden tours are never suggested
            product_search.products = Hidden.Without_Hidden(product_search.products);
            this.product_search = product_search;
        },
        get_Tours(): product_search_product[] {
            return this.suggested_tours;
        },
        // Suggestions are worked out once the product details they depend on are loaded. Working them out on every render
        // let products with not-yet-loaded (blank) details pass releventTour and then drop out as the details arrived, so the cards flickered.
        async Load_Suggestions() {
            const request = ++this.suggestion_request;
            this.loading_suggestions = true;

            const basket_tour_id = this.$store.getters.get_Basket?.trips?.[0]?.tour_id ?? "";
            if (basket_tour_id != "") {
                await Prod.Get_Details(basket_tour_id, this.$store);
            }

            const candidates = Prod.Filtered_Products(this.$store.getters.get_Basket, this.product_search).products
                .filter(product => !this.GetExcludedFromSuggestionList().includes(product.tour_id));

            const Output: product_search_product[] = [];
            const batch_size = 4;

            for (let i = 0; i < candidates.length && Output.length < 2; i += batch_size) {
                const batch = candidates.slice(i, i + batch_size);
                await Promise.all(batch.map(product => Prod.Get_Details(product.tour_id, this.$store)));

                if (request != this.suggestion_request) return; // superseded by a newer load

                batch.forEach(product => {
                    if (Output.length < 2 && this.releventTour(product.tour_id)) {
                        Output.push(product);
                    }
                });
            }

            if (request != this.suggestion_request) return;

            this.suggested_tours = Output;
            this.loading_suggestions = false;
        },
        basket_tour_ids(): string {
            return (this.$store.getters.get_Basket?.trips ?? []).map((trip: trip) => trip.tour_id).join(",");
        },
        releventTour(tour_id : string): boolean {

            if (this.GetExcludedFromSuggestionList().includes(tour_id)) return false;

            let productDetails = Prod.Get_Details_Sync(tour_id, this.$store);
            if (productDetails.tour_id == "") return false; // details failed to load, so relevance can't be checked

            let basketTour = Prod.Get_Details_Sync(this.$store.getters.get_Basket?.trips?.[0]?.tour_id ?? "", this.$store);
            let returnVal: boolean = true;

            this.$store.getters.get_Basket?.trips.forEach((trip: trip) => {
                if(trip.tour_id == tour_id){
                    returnVal = false;
                }
            });

            // productDetails.seller_information.add_ons.forEach(addon => {
            //     basketTour.seller_information.add_ons.forEach(basketAddon => {
            //         if(addon.name == basketAddon.name){
            //             returnVal = false;
            //             return;
            //         }
            //     });
            // });

            if(this.NotBlankString(productDetails.operational_information.location_start.city) && this.NotBlankString(basketTour.operational_information.location_start.city)){
                if(productDetails.operational_information.location_start.city != basketTour.operational_information.location_start.city){
                    returnVal = false;
                }
            }
            return returnVal;
        },
        NotBlankString(Str: string): boolean {
            if (Str == "" || Str == null || Str == undefined) {
                return false;
            }
            else{
                return true;
            }
        },
        View_All_Tours() {
            this.$router.push({ path: "/" });
        },
        DayTourAdded(): boolean {
            let returnVal: boolean = false;

            if(this.isAgent_Login()){
                return returnVal;
            }
            
            this.$store.getters.get_Basket.trips.forEach(trip => {
                if(trip.rooms.length == 0){
                    returnVal = true;
                }
            });
            return returnVal;
        },
        isAgent_Login(): boolean {
            return this.$store.getters.get_Agent_Login?.valid_login == true;
        },
        GetExcludedFromSuggestionList(): string[] {
            return String(import.meta.env.VITE_EXCLUDED_SUGGESTION_TOURS ?? '')
                .split(',')
                .map(tour => tour.trim())
                .filter(Boolean);
        }
    },
    watch: {
        // Re-work out the suggestions when a tour is added to / removed from the basket
        basket_tour_ids_watch() {
            this.Load_Suggestions();
        }
    },
    computed: {
        basket_tour_ids_watch(): string {
            return this.basket_tour_ids();
        }
    },
    async mounted() {
        await this.Download_Product_Search();
        await this.Load_Suggestions();
    }
})